export default {
  title: 'Valor mínimo de pagamento: Os pagamentos não podem ser entre {{rangeStart}} - {{rangeEnd}}',
  description: 'Exceção: Se tiver um artigo grátis, pode finalizar a compra com um total de {{amount}}.',
};
